import {Injectable, Inject} from '@angular/core';
import {v1_loggerServiceName, ILogger} from '@app/v1_integration';

/**
 * Provide logging feature.
 * Note: For now, we create this as a wrapper around V1 logger.
 */
@Injectable()
export class LoggerService {
  constructor(@Inject(v1_loggerServiceName) private _v1Logger: ILogger) {}

  logDebug(
    message: string,
    data: any = null,
    source: string = '',
    showToast: boolean = true
  ) {
    this._v1Logger.logDebug(message, data, source, showToast);
  }
  logInfo(
    message: string,
    data: any = null,
    source: string = '',
    showToast: boolean = true
  ) {
    this._v1Logger.logInfo(message, data, source, showToast);
  }
  logError(
    message: string,
    data: any = null,
    source: string = '',
    showToast: boolean = true
  ) {
    this._v1Logger.logError(message, data, source, showToast);
  }
  logSuccess(
    message: string,
    data: any = null,
    source: string = '',
    showToast: boolean = true
  ) {
    this._v1Logger.logSuccess(message, data, source, showToast);
  }
  logWarning(
    message: string,
    data: any = null,
    source: string = '',
    showToast: boolean = true
  ) {
    this._v1Logger.logWarning(message, data, source, showToast);
  }
}
